export const UNITS = {
    cm: 'cm',
    inches: 'inches',
    default: 'inches',
    factor: {
        inches: 2.54,
        cm: 1
    },
    shortcut: {
        inches: 'in',
        cm: 'cm'
    }
}


// WEBPACK FOOTER //
// ./src/constants/units.js